var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptySearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E9F0",
    d: "M22.546 19.94l6.515 5.51a2.56 2.56 0 11-3.61 3.61l-5.511-6.514A12.444 12.444 0 0112.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5c0 2.787-.912 5.361-2.454 7.44zM12.5 22a9.5 9.5 0 100-19 9.5 9.5 0 000 19zm.925-7.474a.487.487 0 01-.5.474H11.8a.487.487 0 01-.5-.474c0-3.147 2.812-2.85 2.812-5.21 0-.785-.94-1.421-1.906-1.421s-1.922.636-1.922 1.42c-.003.27.041.539.13.795a.466.466 0 01-.305.6.523.523 0 01-.165.027H8.93a.499.499 0 01-.485-.347c-.1-.35-.148-.712-.144-1.074C8.3 7.485 10.091 6 12.3 6c2.21 0 4 1.484 4 3.316 0 3.04-2.875 2.921-2.875 5.21zM12.5 16a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearchIcon);
export default ForwardRef;